import React from 'react';
import PropTypes from 'prop-types';
import './BodyStyle.css'; // Import the CSS file

const BodyExtraSmallMedium = ({ text, color }) => {
  return (
    <p className="body-extra-small-medium" style={{ color: color }}>
      {text}
    </p>
  );
};

BodyExtraSmallMedium.propTypes = {
  text: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
};

export default BodyExtraSmallMedium;